export const styles = () => ({
  name: {
    fontWeight: "bold",
    fontSize: 12,
  },
  type: {
    fontSize: 10,
  },
});
